<template>
  <div>
    <atom-input placeholder="Filter" v-model="messageFilter"></atom-input>
    <atom-multi-select
      style="margin-top: 10px"
      placeholder="Filter Tag"
      :option="tagsList"
      :isEnableProper="false"
      :isAppendToBody="false"
      v-model="selectTagList"
      class="mb-1"
    ></atom-multi-select>
  </div>
</template>

<script>
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
export default {
  name: "MoleculeFilterTag",
  components: {
    AtomInput,
    AtomMultiSelect,
  },
  props: {
    tagsList: {
      type: Array,
      required: true,
    },
  },
  emits: ["messageFilter", "selectTagList"],
  data() {
    return {
      messageFilter: "",
      selectTagList: null,
    }
  },
  watch: {
    messageFilter() {
      this.$emit("messageFilter", this.messageFilter)
    },
    selectTagList() {
      this.$emit("selectTagList", this.selectTagList)
    },
  },
  mounted() {
    this.tagsList = this.tagsList.sort()
  },
}
</script>

<style lang="scss" scoped></style>
